export const COLORS = [
  'var(--color-orange)',
  'var(--color-green)',
  'var(--color-pink)',
  'var(--color-purple)',
  'var(--color-blue)',
];
export const PORTRAIT_POSITIONS = ['right', 'left', 'top-right', 'top-left', 'bottom-right', 'bottom-left'];
export const LANDSCAPE_POSITIONS = ['top', 'bottom', 'top-right', 'top-left', 'bottom-right', 'bottom-left'];
